import type { RouteObject } from 'react-router';

/** / (public) */
export const landingRoutes: RouteObject = {
  index: true,
  lazy: () => import('./LandingPage').then((m) => ({ Component: m.LandingPage })),
};
